<script>
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';
import ErrorState from 'dashboard/components/widgets/ErrorState.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import PromotionCard from './promotionCard.vue';
import AoikumoDisabledTooltip from 'dashboard/components/dahreply/AoikumoDisabledTooltip.vue';

export default {
  name: 'PromotionsList',
  components: {
    LoadingState,
    ErrorState,
    EmptyState,
    PromotionCard,
    AoikumoDisabledTooltip,
  },
  props: {
    promotions: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: 'Failed to load promotions',
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    emptyStateMessage: {
      type: String,
      default: 'Try creating a new promotion to get started.',
    },
    isFilterActive: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['edit', 'delete', 'services', 'retry', 'create'],
  methods: {
    handleEdit(promotion) {
      this.$emit('edit', promotion);
    },
    handleDelete(promotion) {
      this.$emit('delete', promotion);
    },
    handleServices(promotion) {
      this.$emit('services', promotion);
    },
    handleRetry() {
      this.$emit('retry');
    },
    handleCreate() {
      this.$emit('create');
    },
    handleToggle(toggleData) {
      this.$emit('toggle', toggleData);
    }
  },
};
</script>

<template>
  <div>
    <!-- Loading State -->
    <LoadingState v-if="isLoading" message="Loading promotions..." />

    <!-- Error State -->
    <ErrorState
      v-else-if="!isLoading && isError"
      :message="errorMessage"
      @retry="handleRetry"
    />

    <!-- Empty State -->
    <EmptyState
      v-else-if="!isLoading && !isError && isEmpty"
      title="No Promotion Found"
      :message="emptyStateMessage"
    >
      <template v-if="!isFilterActive" #actions>
        <AoikumoDisabledTooltip :disabled="readOnly" class="inline-block">
          <woot-button :is-disabled="readOnly" @click="handleCreate">
            Create Your First Promotion
          </woot-button>
        </AoikumoDisabledTooltip>
      </template>
    </EmptyState>

    <!-- Promotion List -->
    <div v-if="!isLoading && !isEmpty" class="flex flex-col gap-4">
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        <PromotionCard
          v-for="promotion in promotions"
          :key="promotion.id"
          :promotion="promotion"
          :read-only="readOnly"
          @services="handleServices(promotion)"
          @edit="handleEdit(promotion)"
          @delete="handleDelete(promotion)"
          @toggle="handleToggle($event)"
        />
      </div>
    </div>
  </div>
</template>
